import { gql } from 'apollo-angular';

export const FilterEffectsDocument = gql(/* GraphQL*/ `query filterEffects($input: FilterInputGraphql!)
{
  filterEffects(input: $input)
  {
    records{
      name,
      id
    },
    total
  }
}

`);
